import * as React from 'react';

export function joinWith(separator?: string) {
  if (!separator) {
    throw new Error('[helpers.joinWith] A separator must be specified!');
  }

  return function joinWithSeparator(acc: React.ReactChild[], part: React.ReactElement, i: number) {
    const clonedPart = React.cloneElement(part, { ...part.props, key: i });

    return acc.length ? [...acc, separator, clonedPart] : [clonedPart];
  };
}
